"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTokenResponseDto = instanceOfTokenResponseDto;
exports.TokenResponseDtoFromJSON = TokenResponseDtoFromJSON;
exports.TokenResponseDtoFromJSONTyped = TokenResponseDtoFromJSONTyped;
exports.TokenResponseDtoToJSON = TokenResponseDtoToJSON;
exports.TokenResponseDtoToJSONTyped = TokenResponseDtoToJSONTyped;
/**
 * Check if a given object implements the TokenResponseDto interface.
 */
function instanceOfTokenResponseDto(value) {
    if (!('accessToken' in value) || value['accessToken'] === undefined)
        return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined)
        return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined)
        return false;
    return true;
}
function TokenResponseDtoFromJSON(json) {
    return TokenResponseDtoFromJSONTyped(json, false);
}
function TokenResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'accessToken': json['accessToken'],
        'refreshToken': json['refreshToken'],
        'expiresIn': json['expiresIn'],
    };
}
function TokenResponseDtoToJSON(json) {
    return TokenResponseDtoToJSONTyped(json, false);
}
function TokenResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'accessToken': value['accessToken'],
        'refreshToken': value['refreshToken'],
        'expiresIn': value['expiresIn'],
    };
}
